import gsap, { Power1 } from "gsap";

import { GetBy } from "../_app/cuchillo/core/Element";

export default class Curtain {
    _container;
    _progress;

    static init() {
        this._container = GetBy.id('Curtain');
        this._progress = GetBy.class('__progress', this._container)[0];
    }

    static show() {
        gsap.killTweensOf(this._progress);
        this._progress.style.transformOrigin = 'center left';
        gsap.to(this._progress, {
            scaleX: 1,
            ease: Power1.easeOut,
            duration: .6
        });
    }

    static hide() {
        gsap.killTweensOf(this._progress);
        this._progress.style.transformOrigin = 'right center';
        gsap.to(this._progress, {
            scaleX: 0,
            ease: Power1.easeOut,
            duration: .4
        });
    }
}
